<template>
    <div class="main_r_info_box">
        <!-- <div class="time_list_box">
            时间：
            <ul>
                <li class="active" @click="clickTopTimeBtn(0)">2022</li>
                <li @click="clickTopTimeBtn(1)">2021</li>
                <li @click="clickTopTimeBtn(2)">2020</li>
                <li @click="clickTopTimeBtn(3)">2019</li>
            </ul>
        </div> -->
        <ul v-if="articleList.length > 0" class="main_r_info_box_ul">
            <li v-for="(item,i) in articleList" :key="i">
                <a :href="item.contentIsChain == '1' ? item.contentChain : '/detail?docId='+item.id" :title="item.contentTitle" target="_blank" style="display:block;width:100%;height:100%;">
                    <div class="main_r_info_box_li_imgbox">
                        <img class="main_img" :src="(item.imgSrc && item.imgSrc.length > 0) ? imgBase + item.imgSrc[0] : defaultImg1" alt="">
                        <!-- <img class="video_btn" src="../../assets/imgs/video.png" alt="点击播放"> -->
                    </div>
                    <h4 class="main_r_info_box_li_h4">{{item.contentTitle ? item.contentTitle : ''}}</h4>
                     <p class="main_r_info_box_li_p">{{item.contentDescription ? item.contentDescription : ''}}</p>
                    <p class="main_r_info_box_li_time">{{item.contentDatetime ? item.contentDatetime.substring(0,10) : ''}}</p>
                </a>
            </li>
        </ul>
        <div v-if="articleList.length > 0" class="page_box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNum"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-empty v-if="articleList.length <= 0" description="暂无数据!"></el-empty>
    </div>
</template>

<script>

import $ from 'jquery';
import api from "@/../static/api/api.js";

import defaultImg1 from '@/assets/imgs/default.png'
import defaultImg2 from '@/assets/imgs/default2.png'
import defaultImg3 from '@/assets/imgs/default3.png'

export default {
    name: 'imglist',
    props:['currentId'],
    data() {
        return {
            imgBase: this.$store.state.imgBase,
            defaultImg1: defaultImg1,//轮播图默认图片
            defaultImg2: defaultImg2,//研究项目默认图
            defaultImg3: defaultImg3,//交流传播默认图
            articleList: [],//右侧展示文章列表数据
            pageNum: 1,//分页的三个值
            pageSize: 4,
            total: 0,
            curtitle: ''
        }
    },
    watch: {
        currentId (val) {
            this.rightInfoFn(val);
        }
    },
    mounted() {
        this.rightInfoFn(this.currentId);//默认展示CIKD大讲堂
    },
    methods: {
        //点击年份跳转
        clickTopTimeBtn(num){
            $('.time_list_box li').removeClass('active');
            $('.time_list_box li').eq(num).addClass('active');
            let _html = $('.time_list_box li').eq(num).html();
        },
        //加载右侧文章列表数据
        rightInfoFn(index, curNum=1){
            console.log(index,'index')
            let _this = this;
            let menuId = index;
            let pageNum = curNum;
            let pageSize = 4;
            let year = '2021';
            // api.getSpecialArticleList(menuId, pageNum, pageSize, year).then(res => {
            api.getArticleList(menuId, pageNum, pageSize).then(res => {
                if (res.data) {
                    _this.articleList = res.data.list;
                    _this.pageNum = res.data.pageNum;
                    _this.pageSize =res.data.pageSize;
                    _this.total =res.data.total;
                    console.log(res.data.list,'res.data.list');
                    console.log(res.data.title,'res.data');
                    _this.$emit('titleInfo',res.data.categoryPosition);//将当前所属栏目传给父组件
                    _this.curtitle = res.data.title;
                }
            });
        },
        //分页操作函数1
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        //分页操作函数2
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.rightInfoFn(this.currentId, val);
        },
        //鼠标在video列表和是哪个hover显示btn按钮
        videoShowBtn(num, index){
            if(num == 1){
                $('.main_r_info_box_li_imgbox .video_btn').eq(index).css('display','block');
            }
            if(num == 2){
                $('.main_r_info_box_li_imgbox .video_btn').eq(index).css('display','none');
            }
        }
    }
}
</script>

<style scoped>

.main_r_info_box{
    width:100%;
    margin-top:38px;
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 5px 5px 0 rgb(223 226 230 / 75%);
}
.main_r_info_box_ul{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.main_r_info_box_ul li{
    width: 99%;
    height:180px;
    overflow: hidden;
    float: left;
    margin-bottom: 31px;
    border: 1px solid #E8E8E8;
}
.main_r_info_box_ul li:hover{
    box-shadow: 0px 5px 5px 0px rgba(223, 226, 230, 0.75);
}

.main_r_info_box_li_imgbox{
    width: 227px;
    height: 138px;
    overflow: hidden;
    position: relative;
    margin-top:21px;
    margin-left:24px;
    float:left;
}
.main_r_info_box_li_imgbox .main_img{
    width:100%;
    display: block;
}
.main_r_info_box_li_imgbox .video_btn{
    width: 30px;
    height: 30px;
    position: absolute;
    top:66px;
    left:122px;
    display: none;
    cursor: pointer;
}
.main_r_info_box_li_p{
    width: 588px;
    height: 34px;
    font-size: 14px;
    /* font-family: STXihei; */
    font-weight: 400;
    color: #999;
    line-height: 34px;
    float: left;
    margin-left: 28px;
    text-align: left;
    margin-top:22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.main_r_info_box_li_time{
    width: 588px;
    height: 12px;
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    color: #999999;
    line-height: 12px;
    float: left;
    margin-left: 30px;
    text-align: left;
    margin-top:15px;
    margin-right: 10px;
}
.main_r_info_box_li_h4{
    width: 588px;
    height: 18px;
    font-size: 18px;
    /* font-family: STXihei; */
    font-weight: bold;
    color: #333333;
    line-height: 18px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    float: left;
    margin-left: 28px;
    text-align: left;
    margin-top:33px;
}
.time_list_box{
    width:100%;
    height:20px;
    font-size: 14px;
    /* font-family: STXihei; */
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    overflow: hidden;
    text-align: left;
    margin-bottom: 28px;
}
.time_list_box ul{
    display: inline-block;
    margin-left: 16px;
}
.time_list_box ul li{
    display: inline-block;
    width: 66px;
    height: 20px;
    font-size: 14px;
    /* font-family: STXihei; */
    font-weight: 400;
    color: #000;
    line-height: 22px;
    text-align: center;
    margin-right: 7px;
    cursor: pointer;
}
.time_list_box ul li.active{
    background: #1F73C7;
    color: #FFFFFF;
}

/* 分页 */
.page_box{
    width:100%;
    height:63px;
    margin-top:30px;
    margin-bottom:100px;
}





</style>
